import { fetchAttachment } from '../utils/api/requests/requests';
import { getSecuredAssetsUrl } from '../utils/getSecuredAssetsUrl';
import { getCdnUrl } from '../utils/getCdnUrl';

async function fetchTeamAvatar(guid: string) {
  try {
    const URL = await fetchAttachment(
      `${getSecuredAssetsUrl()}/team-member-pictures/${guid}.jpg`
    );
    return URL;
  } catch (error) {
    console.log(error);
    return undefined;
  }
}

export async function setUserAvatar(
  audience: string,
  guid: string,
  employeeNumber?: string
) {
  if (audience === 'OPERATOR_AUDIENCE') {
    return Promise.resolve(
      `${getCdnUrl()}/photos/people/${employeeNumber}.jpg`
    );
  }
  if (audience === 'TEAM_MBR_AUDIENCE') {
    return fetchTeamAvatar(guid).then(res => res);
  }
  return Promise.resolve(
    employeeNumber
      ? `https://prod-cfa-staff-api-employee-images.s3.amazonaws.com/${employeeNumber}.jpg`
      : undefined
  );
}
